import React, { useState, useMemo } from "react";
import "./Home.css";
import { FiPlus, FiMinus, FiSearch } from "react-icons/fi";
// import left from "../../assets/images/heading-left1.jpg";
// import right from "../../assets/images/heading-right.webp";
const faqCategories = {
  "Most Searched": [
    {
      question: "Why should I buy Rudraksha from Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers 100% authentic and certified Rudraksha sourced from trusted origins. Every bead is carefully inspected for quality, ensuring customers receive genuine spiritual products with complete confidence.",
    },
    {
      question:
        "Are all Rudraksha products at Astro Logical Solutions certified?",
      answer:
        "Yes. Every Rudraksha sold by Astro Logical Solutions is quality-checked and comes with a certificate of authenticity, giving you confidence in every purchase.",
    },
    {
      question:
        "Does Astro Logical Solutions sell genuine and natural Rudraksha?",
      answer:
        "Absolutely. We deal only in natural, original, and carefully selected Rudraksha beads. Our products are verified to ensure authenticity and spiritual value.",
    },
    {
      question:
        "How does Astro Logical Solutions verify the authenticity of Rudraksha?",
      answer:
        "Each Rudraksha undergoes a detailed quality inspection before it reaches our customers. We ensure every bead is genuine and meets our strict quality standards.",
    },
    {
      question: "What products are available at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers authentic Rudraksha, Gemstones, Rudraksha Malas, Bracelets, Yantras, Spiritual Accessories, and other astrology-related products.",
    },
    {
      question: "How Can I contact support of Astro Logical Solutions?",
      answer:
        "Email :-  support@astrologicalsolutions.in",
    },
  ],

  "Brand, App & Credentials": [
    {
      question: "How long has Astro Logical Solutions  been in business?",
      answer:
        "We have years of experience in supplying authentic Rudraksha worldwide.",
    },
    {
      question: "Why choose Astro Logical Solutions ",
      answer:
        "Because of genuine sourcing, certification and trusted customer service.",
    },
    {
      question: "Do you provide authenticity certificates?",
      answer:
        "Yes, every original Rudraksha includes an authenticity certificate.",
    },
    {
      question: "Can I trust your online store?",
      answer: "Yes, our website offers secure shopping and verified products.",
    },
    {
      question: "Does Astro Logical Solutions have a mobile app?",
      answer:
        "Currently, Astro Logical Solutions does not have a mobile application. However, our website is fully responsive and can be easily accessed on mobile phones, tablets, and desktops. You can browse products, place orders, and contact our support team directly through our website.",
    },
  ],

  "Care, Maintenance & Longevity": [
    {
      question: "How should I clean my Rudraksha?",
      answer:
        "Clean your Rudraksha gently with fresh water and wipe it with a soft cloth. Applying a small amount of natural oil occasionally helps maintain its condition and longevity.",
    },
    {
      question: "Can Rudraksha get damaged?",
      answer:
        "Yes. Exposure to harsh chemicals, soaps, perfumes, excessive moisture, or rough handling may affect the Rudraksha over time. Proper care helps preserve its natural quality.",
    },
    {
      question: "Should I oil my Rudraksha?",
      answer:
        "Yes. Applying a few drops of natural mustard oil or sandalwood oil every few months can help keep the Rudraksha moisturized and prevent it from drying out.",
    },
    {
      question: "How long does Rudraksha last?",
      answer:
        "An authentic Rudraksha can last for many years or even generations when properly maintained and stored.",
    },
    {
      question: "Is it safe to wear Rudraksha while sleeping or showering?",
      answer:
        "You may wear your Rudraksha while sleeping if it is comfortable. However, it is recommended to remove it before bathing or showering to avoid contact with soap, shampoo, and other chemicals that may affect its natural surface over time.",
    },
  ],

  "Customer Support & Consultation": [
    {
      question: "How do I know which Rudraksha is right for me?",
      answer:
        "Our experts at Astro Logical Solutions help you choose the most suitable Rudraksha based on your spiritual goals, preferences, and requirements.",
    },
    {
      question: "Does Astro Logical Solutions provide product consultation?",
      answer:
        "Yes. We offer expert consultation to help you select the right Rudraksha, gemstones, malas, and other spiritual products before making a purchase.",
    },
    {
      question: "How can I contact Astro Logical Solutions?",
      answer:
        "You can contact Astro Logical Solutions through our website, phone number, email, or WhatsApp. Our support team is happy to assist you with product inquiries and order-related questions.",
    },
    {
      question:
        "What information should I provide to get the right product recommendation?",
      answer:
        "To help us recommend the most suitable product, you can share your requirements, preferences, or any specific spiritual goals. Our experts will guide you accordingly.",
    },
    {
      question:
        "Can Astro Logical Solutions help me choose the right gemstone or Rudraksha?",
      answer:
        "Yes. Our experienced team provides guidance to help you choose the most appropriate Rudraksha or gemstone based on your individual needs.",
    },
    {
      question: "Can I speak with an expert before placing my order?",
      answer:
        "Absolutely. Astro Logical Solutions encourages customers to consult with our experts before purchasing so they can make an informed decision.",
    },
  ],

  "Product & Authenticity": [
    {
      question:
        "What types of Rudraksha products are available at Astro Logical Solutions?",
      answer:
        "Astro Logical Solutions offers a wide range of authentic Rudraksha products, including Single Mukhi to 24 Mukhi Rudraksha, Rudraksha Malas, Bracelets, Pendants, Siddha Malas, and other spiritual accessories.",
    },
    {
      question: "Where are the Rudraksha sourced from?",
      answer:
        "Our Rudraksha beads are sourced from trusted regions, including Nepal and Indonesia, and are carefully selected to ensure authenticity and quality.",
    },
    {
      question: "Are the Rudraksha beads authentic and natural?",
      answer:
        "Yes. Astro Logical Solutions offers only genuine, natural, and carefully verified Rudraksha beads. Every product undergoes quality inspection before being delivered.",
    },
    {
      question: "Do all Rudraksha products come with a certificate?",
      answer:
        "Yes. Most of our Rudraksha products are provided with an authenticity certificate to assure customers of their originality and quality.",
    },
    {
      question: "Why should I wear a Rudraksha?",
      answer:
        "Rudraksha is traditionally believed to promote inner peace, spiritual growth, focus, and positive energy. Many people wear it as part of their spiritual and meditation practices.",
    },
    {
      question: "How can I verify the authenticity of my Rudraksha?",
      answer:
        "Astro Logical Solutions carefully verifies every Rudraksha before sale. We also provide authenticity certification for eligible products, giving customers complete confidence in their purchase.",
    },
    {
      question: "Are your Rudraksha products securely packed?",
      answer:
        "Yes. Every order is packed securely to protect the Rudraksha during transit and ensure it reaches you in excellent condition.",
    },
    {
      question: "Do you offer Gauri Shankar Rudraksha and Trijuti Rudraksha?",
      answer:
        "Yes. Astro Logical Solutions offers a selection of premium Rudraksha varieties, including Gauri Shankar and Trijuti Rudraksha, subject to availability.",
    },
    {
      question: "Do you offer Rudraksha Malas and custom combinations?",
      answer:
        "Yes. We offer Rudraksha Malas, bracelets, pendants, and selected customized combinations based on customer requirements and product availability.",
    },
  ],

  "Payments, Security & Cancellation": [
    {
      question: "Which payment methods does Astro Logical Solutions accept?",
      answer:
        "Astro Logical Solutions accepts UPI, Credit Cards, Debit Cards, Net Banking, Wallets, and other secure online payment methods. Available payment options may vary depending on your location.",
    },
    {
      question:
        "Can I make payments using international credit or debit cards?",
      answer:
        "Yes. Astro Logical Solutions supports secure payments through most major international credit and debit cards, subject to payment gateway availability and your card provider's policies.",
    },
    {
      question: "Can I pay in different currencies?",
      answer:
        "International customers may be able to pay in supported currencies depending on the payment gateway. Any currency conversion is handled by your bank or card provider.",
    },
    {
      question: "Is my payment information secure?",
      answer:
        "Yes. Astro Logical Solutions uses trusted and secure payment gateways to protect your payment information. We do not store your card or banking details on our website.",
    },
    {
      question: "Can I cancel my order after placing it?",
      answer:
        "Yes. Orders can usually be cancelled before they are processed or shipped. Please contact our customer support as soon as possible if you wish to cancel your order.",
    },
    {
      question: "Will I receive a payment confirmation?",
      answer:
        "Yes. Once your payment is successfully completed, you will receive an order confirmation through your registered email address or mobile number.",
    },
    {
      question: "What should I do if my payment fails?",
      answer:
        "If your payment fails, please try again after a few minutes or use another payment method. If the issue continues, contact Astro Logical Solutions customer support for assistance.",
    },
  ],

  "Pricing, Offers & Customization": [
    {
      question:
        "Why are the prices at Astro Logical Solutions different from other sellers?",
      answer:
        "Our products are carefully selected for quality and authenticity. We focus on providing genuine Rudraksha, certified gemstones, and premium spiritual products, ensuring customers receive reliable and trusted items.",
    },
    {
      question:
        "What is the price range of products at Astro Logical Solutions?",
      answer:
        "Our product prices vary depending on the type, quality, size, and rarity. We offer a wide range of options to suit different budgets, from affordable spiritual products to premium collections.",
    },
    {
      question: "Do you offer discounts or special offers?",
      answer:
        "Yes. Astro Logical Solutions regularly offers seasonal promotions, festive discounts, and exclusive deals on selected products. Please visit our website or follow our latest updates for current offers.",
    },
    {
      question: "Can I customize my Rudraksha Mala or Bracelet?",
      answer:
        "Yes. We offer customization options for selected Rudraksha malas, bracelets, and spiritual accessories based on your preferences and product availability.",
    },
    {
      question: "Is there any additional charge for customization?",
      answer:
        "Customization charges, if applicable, depend on the type of product, design, and materials used. Our team will inform you of any additional cost before confirming your order.",
    },
    {
      question:
        "Can I request a custom combination of Rudraksha and gemstones?",
      answer:
        "Yes. Astro Logical Solutions offers selected custom combinations of Rudraksha and gemstones based on your requirements and product availability.",
    },
    {
      question: "How can I know about the latest offers?",
      answer:
        "You can check our official website regularly or contact our customer support team to stay updated about the latest discounts, promotions, and special offers.",
    },
  ],

  "Astro Logical Solutions Brand": [
    {
      question: "What makes Astro Logical Solutions  different?",
      answer:
        "Authenticity, quality, certification and trusted customer service.",
    },
    {
      question: "Do you provide lifetime support?",
      answer:
        "Yes, customers receive after-sales support for product guidance.",
    },
    {
      question: "Why is Astro Logical Solutions  trusted worldwide?",
      answer:
        "Because of transparent sourcing, certified products and customer satisfaction.",
    },
  ],
};

export default function QuestionsFAQ() {
  const categoryList = Object.keys(faqCategories);

  const [selectedCategory, setSelectedCategory] = useState(categoryList[0]);
  const [openIndex, setOpenIndex] = useState(null);
  const [searchText, setSearchText] = useState("");

  const currentFaqs = useMemo(() => {
    return faqCategories[selectedCategory].filter((faq) =>
      faq.question.toLowerCase().includes(searchText.toLowerCase()),
    );
  }, [selectedCategory, searchText]);

  return (
    <section className="rqf-section">
      <div className="rqf-title">
        <div className="heading-wrapper">
          <h2>
            Questions About <span>Astro Logical</span>
          </h2>
          <div className="about-heading-line">
            <img
              src="https://res.cloudinary.com/dbb2hkjri/image/upload/v1786441287/1684481897-flower-divider-horizontal-orange_f2omyx.svg"
              alt="Heading decoration"
            />
          </div>
        </div>
        <p>
          From respected media outlets to spiritual thought leaders, discover
          why Astro Logical continues to be a trusted name worldwide.
        </p>
      </div>
      <div className="rqf-wrapper">
        <aside className="rqf-sidebar">
          {categoryList.map((category) => (
            <button
              key={category}
              className={`rqf-category-btn ${selectedCategory === category ? "rqf-active" : ""
                }`}
              onClick={() => {
                setSelectedCategory(category);
                setOpenIndex(null);
                setSearchText("");
              }}
            >
              {category}
            </button>
          ))}
        </aside>

        {/* RIGHT SIDE */}

        <div className="rqf-content">
          <div className="rqf-search">
            <input
              type="text"
              placeholder="Search questions..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            <FiSearch />
          </div>

          {currentFaqs.length > 0 ? (
            currentFaqs.map((item, index) => (
              <div className="rqf-card" key={index}>
                <div
                  className="rqf-question"
                  onClick={() =>
                    setOpenIndex(openIndex === index ? null : index)
                  }
                >
                  <span>{item.question}</span>

                  {openIndex === index ? <FiMinus /> : <FiPlus />}
                </div>

                {openIndex === index && (
                  <div className="rqf-answer">{item.answer}</div>
                )}
              </div>
            ))
          ) : (
            <div className="rqf-empty">No questions found.</div>
          )}
        </div>
      </div>
    </section>
  );
}
